import separateColorAndOpacity from "utils/separateColorAndOpacity";
import mapboxgl from "mapbox-gl";
import { getRegionLayerData } from "../../../../../../../../store/dashboard/observationsByRegion/reducer.actions";
import ellipsize from "ellipsize";
import "./mapStyle.css";

function __paintShapeByGeoJsonOnMap__(
  map: any,
  sourceId: string,
  layerId: string,
  geoJson: any,
  defaultColor: any,
  defaultBorderColor: any,
  popupRef?: any,
  dispatch?: any,
  regionData?: any
) {
  if (!map || !sourceId || !layerId || !geoJson) {
    return;
  }

  // adding geojson source
  map.addSource(sourceId, {
    type: "geojson",
    data: geoJson,
  });

  const isGeoJsonHasLineString = geoJson && geoJson?.features?.find(
    (f: any) =>
      f.geometry.type === "LineString" || f.geometry.type === "MultiLineString"
  );

  const {color,opacity} = separateColorAndOpacity(defaultColor);
  const {color: borderColor,opacity: borderOpacity} = separateColorAndOpacity(defaultBorderColor);
 

  // // design and register the added geojson source layer
  map.addLayer({
    id: layerId,
    type: isGeoJsonHasLineString ? "line" : "fill",
    source: sourceId,
    layout: {},
    paint: {
      [isGeoJsonHasLineString ? "line-color" : "fill-color"]: color,
      [isGeoJsonHasLineString ? "line-opacity" : "fill-opacity"]: opacity,
    },
  });

  if (!isGeoJsonHasLineString) {
    map.addLayer({
      id: `${layerId}-border`,
      type: "line",
      source: sourceId,
      layout: {},
      paint: {
        "line-color": borderColor || "#000000", 
        "line-width": 1, 
        "line-opacity": borderOpacity,
      },
    });
  }
  /** Function to display tooltip with region name */
  map.on("click", (e: any) => {
    const features = map.queryRenderedFeatures(e.point);
    const coordinates: [number, number] = [e.lngLat.lng, e.lngLat.lat];
    if (features.length === 0) {
      dispatch(getRegionLayerData(null));
      if (popupRef.current) {
        popupRef.current.remove();
        popupRef.current = null;
      }
      return;
    }
    const clickedFeature = features[0];
    const clickedLayerId = clickedFeature.layer.id;
    const clickedFeatureId = clickedFeature.id?.toString();
    // Only react to region layers like "region#0-layer", "region#1-layer", etc.
    if (/^region#\d+-layer$/.test(clickedLayerId)) {
      // Loop through all data items to find a matching feature by ID
      const matchedItem: any = regionData?.find((item: any) =>
        item?.mapData?.features?.some(
          (f: any) => f?.id?.toString() === clickedFeatureId
        )
      );
      dispatch(getRegionLayerData(matchedItem));

      // Clear previous popup if any
      if (popupRef.current) {
        popupRef.current.remove();
        popupRef.current = null;
      }

      // Create and show new popup
      const popup = new mapboxgl.Popup({
        closeOnClick: true,
        className: "main-popup popup-height",
        closeButton: false,
      })
        .setLngLat(coordinates)
        .setHTML(
          `
          <div class='flex items-center justify-center capitalize h-full'>
            <p class='text-textNormal flex flex-wrap justify-center text-center items-center h-full'>
             ${ellipsize(matchedItem?.regionName, 50)}
            </p>
          </div>
        `
        )
        .addTo(map);

      popupRef.current = popup;
    }
  });
}

export { __paintShapeByGeoJsonOnMap__ };
